var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { faEye, faEyeSlash } from "@fortawesome/free-regular-svg-icons";
import { faCaretDown, faCaretUp, faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { getConfigVar } from "../../utils/Configuration";
import { concatClassNames } from "../../utils/Functions";
import { Button } from "../layout/Button";
import { Tooltip } from "../layout/Tooltip";
import { BaseInput } from "./BaseInput";
var Input = /** @class */ (function (_super) {
    __extends(Input, _super);
    function Input(props) {
        var _this = this;
        var defaultValue = props.defaultValue, type = props.type, min = props.min, max = props.max, decimals = props.decimals;
        var defaultV;
        if (defaultValue != null) {
            if (type === "number") {
                if (min != null && Number(defaultValue) < min)
                    defaultV = min;
                else if ((max != null && Number(defaultValue) > max) || isNaN(Number(defaultValue)))
                    defaultV = min != null ? min : "";
                else
                    defaultV = defaultValue;
            }
            else
                defaultV = props.maxLength != null && defaultValue.toString().length > props.maxLength ? "" : defaultValue;
        }
        else
            defaultV = "";
        _this = _super.call(this, props, {
            showPassword: false
        }, decimals != null && type === "number" && defaultV !== "" ? Number(defaultV).toFixed(decimals) : defaultV) || this;
        _this.resetting = false;
        _this.componentDidUpdate = function (prevProps) {
            if (prevProps.defaultValue !== _this.props.defaultValue)
                _this.dispatchValue(_this.props.defaultValue);
        };
        _this.changeValue = function (e) {
            var _a = _this.props, disabled = _a.disabled, type = _a.type, onChange = _a.onChange, value = type === "number" ? Number(e.target.value) : e.target.value, nativeEvent = e.nativeEvent, dispatchChange = function (val) {
                if (val === void 0) { val = value; }
                if (onChange)
                    onChange(val, e);
            };
            if (disabled)
                return;
            if (type === "number") {
                if (nativeEvent.isBase && !_this.checkNumberValidity(value))
                    return;
                else if (!nativeEvent.isBase) {
                    if (!_this.checkNumberValidity(value))
                        return dispatchChange(_this.state.value);
                    _this.setInternalValue(e.target.value.toString());
                    return dispatchChange();
                }
            }
            _this.setState({ value: value }, dispatchChange);
        };
        _this.checkNumberValidity = function (value) {
            var _a = _this.props, min = _a.min, max = _a.max;
            if (isNaN(value))
                return false;
            if (min != null && value < min)
                return false;
            if (max != null && value > max)
                return false;
            return true;
        };
        _this.togglePassword = function () { return _this.setState({ showPassword: !_this.state.showPassword }); };
        _this.checkKeyArrowUpOrDown = function (e) {
            var _a = _this.props, onKey = _a.onKey, type = _a.type, disabled = _a.disabled, value = _this.state.value;
            if (disabled)
                return;
            if (onKey)
                onKey(e, "keydown");
            if (type !== "number")
                return;
            if (e.key === "ArrowUp")
                _this.dispatchValue((value + 1).toString());
            else if (e.key === "ArrowDown")
                _this.dispatchValue((value - 1).toString());
            else if (e.key === "Enter")
                _this.blurInput(e);
        };
        _this.reset = function () {
            _this.resetting = true;
            var _a = _this.props, disabled = _a.disabled, min = _a.min, type = _a.type;
            if (disabled)
                return;
            if (type !== "number")
                _this.dispatchValue("");
            else if (min != null)
                _this.dispatchValue(min.toString());
            else
                _this.dispatchValue("0");
            setTimeout(function () { return _this.input.focus(); });
        };
        _this.blurInput = function (e) {
            var _a = _this.props, disabled = _a.disabled, onBlur = _a.onBlur, type = _a.type, onChange = _a.onChange, decimals = _a.decimals, internalValue = _this.state.internalValue;
            if (disabled)
                return;
            if ((type !== "number" && onBlur) || _this.resetting) {
                if (_this.resetting)
                    _this.resetting = false;
                else
                    onBlur(e);
            }
            else if (type === "number") {
                if (internalValue) {
                    var nValue = Number(internalValue);
                    if (!isNaN(nValue) && _this.checkNumberValidity(nValue)) {
                        var value_1 = decimals != null ? nValue.toFixed(decimals) : nValue;
                        _this.setState({ value: value_1 }, function () {
                            if (onChange)
                                onChange(value_1, e);
                        });
                    }
                }
                else if (internalValue === "") {
                    _this.setState({ value: "" }, function () {
                        if (onChange)
                            onChange(null, e);
                    });
                }
                _this.setInternalValue(null);
                setTimeout(function () {
                    if (onBlur)
                        onBlur(e);
                });
            }
        };
        _this.clickButtons = function (decrease) {
            if (decrease === void 0) { decrease = false; }
            _this.resetting = true;
            var steps = Math.abs(_this.props.steps || 1), value = _this.state.value;
            if (decrease)
                _this.dispatchValue(Number(value) - steps);
            else
                _this.dispatchValue(Number(value) + steps);
            setTimeout(function () { return _this.input.focus(); });
        };
        _this.render = function () {
            var _a = _this.props, type = _a.type, disabled = _a.disabled, showPasswordToggle = _a.showPasswordToggle, required = _a.required, autoComplete = _a.autoComplete, autoFocus = _a.autoFocus, className = _a.className, name = _a.name, onBlur = _a.onBlur, onFocus = _a.onFocus, style = _a.style, onKey = _a.onKey, rows = _a.rows, resize = _a.resize, maxLength = _a.maxLength, placeHolder = _a.placeHolder, inputType = type || "text", _b = _this.state, value = _b.value, showPassword = _b.showPassword, internalValue = _b.internalValue;
            if (inputType !== "textarea") {
                return React.createElement("div", { className: "dolfo-control" },
                    _this.getLabel(),
                    React.createElement("div", { className: "dolfo-input-container" },
                        React.createElement("input", { ref: function (r) { return _this.input = r; }, type: inputType === "number" || (type === "password" && showPassword) ? "text" : inputType, value: internalValue != null ? internalValue : value, disabled: disabled, required: required, autoFocus: autoFocus, autoComplete: autoComplete, maxLength: maxLength, className: concatClassNames(["dolfo-input-text", inputType], className), style: style, name: name, onBlur: _this.blurInput, onFocus: onFocus, onKeyDown: _this.checkKeyArrowUpOrDown, onKeyUp: function (e) { return onKey && !disabled && onKey(e, "keyup"); }, onChange: _this.changeValue, placeholder: placeHolder }),
                        !disabled && type === "number" ? React.createElement("div", { className: "dolfo-input-buttons" },
                            React.createElement(Tooltip, { label: getConfigVar("INCREASE"), position: "left" },
                                React.createElement(Button, { color: "white", onMouseDown: function () { return _this.clickButtons(); }, size: "small" },
                                    React.createElement(FontAwesomeIcon, { icon: faCaretUp }))),
                            React.createElement(Tooltip, { label: getConfigVar("DECREASE"), position: "left" },
                                React.createElement(Button, { color: "white", onMouseDown: function () { return _this.clickButtons(true); }, size: "small" },
                                    React.createElement(FontAwesomeIcon, { icon: faCaretDown })))) : React.createElement(React.Fragment, null),
                        !disabled && value && type !== "number" && type !== "password" ? React.createElement(Tooltip, { label: getConfigVar("RESET"), position: "left" },
                            React.createElement(FontAwesomeIcon, { icon: faXmark, className: "dolfo-input-reset", onMouseDown: _this.reset })) : React.createElement(React.Fragment, null),
                        !disabled && value && showPasswordToggle && type === "password" ? React.createElement(Tooltip, { label: getConfigVar("SHOW"), position: "left" },
                            React.createElement(FontAwesomeIcon, { icon: showPassword ? faEyeSlash : faEye, className: "dolfo-input-reset", onClick: _this.togglePassword })) : React.createElement(React.Fragment, null)));
            }
            return React.createElement("div", { className: "dolfo-control" },
                _this.getLabel(),
                React.createElement("textarea", { ref: function (r) { return _this.input = r; }, value: value, disabled: disabled, required: required, autoFocus: autoFocus, autoComplete: autoComplete, maxLength: maxLength, rows: rows !== null && rows !== void 0 ? rows : 1, className: concatClassNames(["dolfo-input-textarea", resize ? ("resizable" + (typeof resize === "string" ? "-" + resize : "")) : ""], className), style: style, name: name, onBlur: onBlur, onFocus: onFocus, onKeyDown: function (e) { return onKey && !disabled && onKey(e, "keydown"); }, onKeyUp: function (e) { return onKey && !disabled && onKey(e, "keyup"); }, onChange: _this.changeValue, placeholder: placeHolder }));
        };
        return _this;
    }
    return Input;
}(BaseInput));
export { Input };
